import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  it: {
    app_tagline: "Piccoli interventi domestici a Roma, semplici come ordinare a domicilio",
    request_intervention: "Richiedi un intervento",
    my_orders: "I miei ordini",
    login: "Accedi", register: "Registrati", logout: "Esci",
    email: "Email", password: "Password", name: "Nome e cognome", phone: "Telefono",
    login_google: "Continua con Google",
    no_account: "Non hai un account?", have_account: "Hai già un account?",
    forgot_password: "Password dimenticata?", reset_password: "Reimposta la password",
    back_to_login: "Torna all'accesso", send_reset: "Invia link di recupero", new_password: "Nuova password",
    role: "Tipo di account", role_cliente: "Cliente", role_tecnico: "Tecnico",
    categories: "Cosa ti serve?",
    step: "Passo", of: "di", next: "Avanti", back: "Indietro", send_request: "Invia richiesta",
    problem: "Qual è il problema?", problem_ph: "Es. Serratura bloccata",
    description: "Descrizione", description_ph: "Descrivi il problema con qualche dettaglio…",
    photos: "Foto (1–5)", add_photo: "Aggiungi foto", uploading: "Caricamento…",
    address: "Indirizzo", address_ph: "Via e numero civico", city: "Città",
    address_details: "Dettagli per raggiungerti", address_details_ph: "Piano, interno, citofono, note…",
    time_slot: "Fascia oraria desiderata", urgency: "Urgenza",
    urgency_normale: "Normale", urgency_urgente: "Urgente", urgency_emergenza: "Emergenza",
    contact: "Contatti", summary: "Riepilogo",
    order_code: "Codice richiesta", status: "Stato",
    quote: "Preventivo", call_out_fee: "Diritto di chiamata", labor: "Manodopera",
    materials: "Materiali", surcharges: "Supplementi", total: "Totale", included: "Cosa è incluso",
    validity: "Validità prezzo", eta: "Tempo stimato di arrivo",
    accept_quote: "Accetta preventivo", reject_quote: "Rifiuta",
    contact_central: "Contatta la centrale", pay_now: "Paga ora", pay_card: "Paga con carta", or: "oppure", secure_payment: "Pagamento sicuro", receipt: "Ricevuta",
    rate_work: "Valuta l'intervento", your_rating: "La tua valutazione", leave_comment: "Lascia un commento…",
    submit_rating: "Invia valutazione", thanks_rating: "Grazie per la tua valutazione!",
    progress: "Avanzamento", history: "Cronologia", out_of_zone_warn: "Indirizzo fuori zona: verifica manuale necessaria",
    tech_area: "Area Tecnico", assigned_jobs: "Interventi assegnati", no_jobs: "Nessun intervento assegnato",
    accept_job: "Accetta incarico", departing: "In partenza", arrived: "Sono arrivato",
    work_started: "Lavoro iniziato", work_completed: "Lavoro completato",
    upload_final: "Carica foto finali", request_variation: "Segnala variazione di prezzo",
    agreed_fee: "Compenso concordato", variation_reason: "Motivo della variazione", variation_amount: "Importo aggiuntivo (€)",
    admin_area: "Centrale Operativa", dashboard: "Dashboard", new_requests: "Nuove richieste",
    all_orders: "Tutti gli ordini", create_quote: "Crea preventivo", send_quote: "Invia preventivo al cliente",
    assign_tech: "Assegna tecnico", select_tech: "Seleziona un tecnico",
    update_eta: "Aggiorna ETA", internal_fields: "Campi interni (non visibili al cliente)",
    technician_pay: "Compenso tecnico", other_costs: "Altri costi diretti",
    customer_source: "Provenienza cliente", estimated_margin: "Margine stimato",
    save: "Salva", approve: "Approva", reject: "Rifiuta", refund: "Rimborsa", cancel: "Annulla ordine",
    filters: "Filtri", filter_status: "Stato", filter_category: "Categoria", filter_tech: "Tecnico", filter_date: "Data",
    settings: "Impostazioni", zones_served: "Zone servite", hours: "Orari",
    variation_pending: "Variazione da approvare", approve_variation: "Gestisci variazione",
    urgent: "URGENTE", demo: "DEMO", loading: "Caricamento…", none: "—",
    nav_request: "Richiedi", add_technician: "Aggiungi tecnico", create: "Crea",
    alerts_title: "Avvisi nuove richieste", integration_status: "Stato integrazione",
    integration_to_configure: "Integrazione da configurare", integration_ready: "Integrazione attiva",
    integration_help: "Aggiungi le credenziali Twilio sul server (mai nel browser) per attivare WhatsApp e chiamata:",
    take_charge: "Prendo in carico", taken_charge: "Presa in carico", arrived_ago: "Arrivata",
    whatsapp_number: "Numero WhatsApp destinatario", call_number: "Numero da chiamare",
    call_hours: "Orari chiamate", call_mode: "Quando chiamare",
    call_mode_all: "Tutte le richieste", call_mode_urgent: "Solo urgenti",
    second_number: "Secondo numero (reperibilità)", retry_after: "Riprova / 2° numero dopo (min)",
    alert_whatsapp: "WhatsApp", alert_call: "Chiamata", resend_alerts: "Reinvia avvisi",
    st_sent: "Inviato", st_failed: "Fallito", st_pending: "In attesa", st_config: "Da configurare", st_skipped: "Saltato",
    min_ago: "min fa", hours_ago: "h fa", just_now: "adesso", day_ago: "g fa",
    urgency_surcharge: "Supplemento urgenza/fuori orario", discount: "Sconto", exclusions: "Esclusioni",
    quote_versions: "Versioni preventivo", accepted_on: "Accettato il", payment_state: "Stato pagamento",
    ps_not_started: "Non avviato", ps_authorized: "Autorizzato", ps_succeeded: "Riuscito", ps_failed: "Fallito", ps_refunded: "Rimborsato",
    revenue: "Incasso", margin: "Margine", variation_proposed: "Proposta di variazione prezzo",
    accept_variation: "Accetta variazione", reject_variation: "Rifiuta variazione", propose_variation: "Proponi variazione al cliente",
    access_verification: "Verifica diritto di accesso", access_checklist: "Checklist interna",
    av_verified: "Verificato", av_contested: "Contestato", av_suspended: "Sospeso", av_pending: "Da verificare",
    complete_verification: "Registra verifica", confirm_access_onsite: "Confermo verifica sul posto (obbligatorio)",
    access_confirmed: "Verifica confermata sul posto", lock_details: "Dettagli porta e serratura",
    door_state: "Stato porta", door_accostata: "Accostata", door_chiusa: "Chiusa a chiave",
    lock_issue: "Problema", issue_chiavi_interno: "Chiavi all'interno", issue_smarrite: "Chiavi smarrite", issue_spezzate: "Chiavi spezzate", issue_serratura_bloccata: "Serratura bloccata",
    door_type: "Tipo porta", door_normale: "Normale", door_blindata: "Blindata",
    relationship: "Rapporto con l'immobile", rel_proprietario: "Proprietario", rel_inquilino: "Inquilino", rel_ospite: "Ospite", rel_gestore: "Gestore", rel_altro: "Altro",
    skills: "Competenze", certifications: "Abilitazioni", zones: "Zone", available: "Disponibile", manage_techs: "Gestione tecnici",
    retry_payment: "Riprova pagamento", disclaimer_verification: "La checklist digitale NON sostituisce la verifica reale sul posto.",
    emergency_note: "Nota emergenze", alert_telegram: "Telegram", alert_email: "Email cliente",
    total_orders: "Ordini totali", active_orders: "In corso", paid_orders: "Pagati",
    customer: "Cliente", technician: "Tecnico", no_orders: "Nessun ordine ancora",
    final_photos: "Foto finali lavoro", payment_ok: "Pagamento completato!", payment_cancel: "Pagamento annullato",
    view: "Apri", welcome: "Benvenuto", home: "Home",
    customer_reviews: "Recensioni dei clienti", reviews: "recensioni",
    review_invite_title: "Com'è andato il tuo intervento?", review_invite_cta: "Lascia una recensione", leave_review: "Lascia una recensione", review_help: "La tua opinione aiuta altri clienti a scegliere",
    alerts_history: "Storico avvisi", alarm_arm: "Attiva allarme", alarm_on: "Allarme attivo", alarm_off: "Allarme spento",
    new_urgent_alert: "Nuova richiesta urgente in arrivo!", al_channel: "Canale", al_status: "Stato", al_when: "Quando", al_all: "Tutti",
    al_no_history: "Nessun avviso registrato", resend: "Reinvia", resend_sent: "Avvisi reinviati",
    ch_telegram: "Telegram", ch_whatsapp: "WhatsApp", ch_call: "Chiamata", ch_client_quote: "Email preventivo", ch_client_eta: "Email arrivo", ch_call_retry: "Richiamata",
  },
  en: {
    app_tagline: "Small home repairs in Rome, as easy as ordering food",
    request_intervention: "Request a service",
    my_orders: "My orders",
    login: "Sign in", register: "Sign up", logout: "Log out",
    email: "Email", password: "Password", name: "Full name", phone: "Phone",
    login_google: "Continue with Google",
    no_account: "No account yet?", have_account: "Already have an account?",
    forgot_password: "Forgot password?", reset_password: "Reset password",
    back_to_login: "Back to sign in", send_reset: "Send reset link", new_password: "New password",
    role: "Account type", role_cliente: "Customer", role_tecnico: "Technician",
    categories: "What do you need?",
    step: "Step", of: "of", next: "Next", back: "Back", send_request: "Send request",
    problem: "What's the problem?", problem_ph: "E.g. Jammed lock",
    description: "Description", description_ph: "Describe the problem with some detail…",
    photos: "Photos (1–5)", add_photo: "Add photo", uploading: "Uploading…",
    address: "Address", address_ph: "Street and number", city: "City",
    address_details: "How to reach you", address_details_ph: "Floor, unit, intercom, notes…",
    time_slot: "Preferred time slot", urgency: "Urgency",
    urgency_normale: "Normal", urgency_urgente: "Urgent", urgency_emergenza: "Emergency",
    contact: "Contact", summary: "Summary",
    order_code: "Request code", status: "Status",
    quote: "Quote", call_out_fee: "Call-out fee", labor: "Labor",
    materials: "Materials", surcharges: "Surcharges", total: "Total", included: "What's included",
    validity: "Price validity", eta: "Estimated arrival time",
    accept_quote: "Accept quote", reject_quote: "Reject",
    contact_central: "Contact the office", pay_now: "Pay now", pay_card: "Pay by card", or: "or", secure_payment: "Secure payment", receipt: "Receipt",
    rate_work: "Rate the service", your_rating: "Your rating", leave_comment: "Leave a comment…",
    submit_rating: "Submit rating", thanks_rating: "Thanks for your rating!",
    progress: "Progress", history: "History", out_of_zone_warn: "Address out of zone: manual verification needed",
    tech_area: "Technician Area", assigned_jobs: "Assigned jobs", no_jobs: "No assigned jobs",
    accept_job: "Accept job", departing: "Departing", arrived: "I've arrived",
    work_started: "Work started", work_completed: "Work completed",
    upload_final: "Upload final photos", request_variation: "Report price variation",
    agreed_fee: "Agreed fee", variation_reason: "Variation reason", variation_amount: "Additional amount (€)",
    admin_area: "Operations Center", dashboard: "Dashboard", new_requests: "New requests",
    all_orders: "All orders", create_quote: "Create quote", send_quote: "Send quote to customer",
    assign_tech: "Assign technician", select_tech: "Select a technician",
    update_eta: "Update ETA", internal_fields: "Internal fields (hidden from customer)",
    technician_pay: "Technician pay", other_costs: "Other direct costs",
    customer_source: "Customer source", estimated_margin: "Estimated margin",
    save: "Save", approve: "Approve", reject: "Reject", refund: "Refund", cancel: "Cancel order",
    filters: "Filters", filter_status: "Status", filter_category: "Category", filter_tech: "Technician", filter_date: "Date",
    settings: "Settings", zones_served: "Served zones", hours: "Hours",
    variation_pending: "Variation to approve", approve_variation: "Manage variation",
    urgent: "URGENT", demo: "DEMO", loading: "Loading…", none: "—",
    nav_request: "Request", add_technician: "Add technician", create: "Create",
    alerts_title: "New request alerts", integration_status: "Integration status",
    integration_to_configure: "Integration to configure", integration_ready: "Integration active",
    integration_help: "Add the Twilio credentials on the server (never in the browser) to enable WhatsApp and calls:",
    take_charge: "Take charge", taken_charge: "Taken in charge", arrived_ago: "Arrived",
    whatsapp_number: "WhatsApp recipient number", call_number: "Number to call",
    call_hours: "Call hours", call_mode: "When to call",
    call_mode_all: "All requests", call_mode_urgent: "Urgent only",
    second_number: "Second number (on-call)", retry_after: "Retry / 2nd number after (min)",
    alert_whatsapp: "WhatsApp", alert_call: "Call", resend_alerts: "Resend alerts",
    st_sent: "Sent", st_failed: "Failed", st_pending: "Pending", st_config: "To configure", st_skipped: "Skipped",
    min_ago: "min ago", hours_ago: "h ago", just_now: "now", day_ago: "d ago",
    urgency_surcharge: "Urgency/after-hours surcharge", discount: "Discount", exclusions: "Exclusions",
    quote_versions: "Quote versions", accepted_on: "Accepted on", payment_state: "Payment state",
    ps_not_started: "Not started", ps_authorized: "Authorized", ps_succeeded: "Succeeded", ps_failed: "Failed", ps_refunded: "Refunded",
    revenue: "Revenue", margin: "Margin", variation_proposed: "Price variation proposal",
    accept_variation: "Accept variation", reject_variation: "Reject variation", propose_variation: "Propose variation to customer",
    access_verification: "Access-right verification", access_checklist: "Internal checklist",
    av_verified: "Verified", av_contested: "Contested", av_suspended: "Suspended", av_pending: "To verify",
    complete_verification: "Record verification", confirm_access_onsite: "I confirm on-site verification (required)",
    access_confirmed: "Verification confirmed on-site", lock_details: "Door & lock details",
    door_state: "Door state", door_accostata: "Just closed", door_chiusa: "Locked",
    lock_issue: "Issue", issue_chiavi_interno: "Keys inside", issue_smarrite: "Keys lost", issue_spezzate: "Keys broken", issue_serratura_bloccata: "Lock jammed",
    door_type: "Door type", door_normale: "Standard", door_blindata: "Armored",
    relationship: "Relationship to property", rel_proprietario: "Owner", rel_inquilino: "Tenant", rel_ospite: "Guest", rel_gestore: "Manager", rel_altro: "Other",
    skills: "Skills", certifications: "Certifications", zones: "Zones", available: "Available", manage_techs: "Technician management",
    retry_payment: "Retry payment", disclaimer_verification: "The digital checklist does NOT replace the real on-site verification.",
    emergency_note: "Emergency note", alert_telegram: "Telegram", alert_email: "Client email",
    total_orders: "Total orders", active_orders: "Active", paid_orders: "Paid",
    customer: "Customer", technician: "Technician", no_orders: "No orders yet",
    final_photos: "Final work photos", payment_ok: "Payment complete!", payment_cancel: "Payment cancelled",
    view: "Open", welcome: "Welcome", home: "Home",
    customer_reviews: "Customer reviews", reviews: "reviews",
    review_invite_title: "How was your service?", review_invite_cta: "Leave a review", leave_review: "Leave a review", review_help: "Your feedback helps other customers choose",
    alerts_history: "Alerts history", alarm_arm: "Enable alarm", alarm_on: "Alarm on", alarm_off: "Alarm off",
    new_urgent_alert: "New urgent request incoming!", al_channel: "Channel", al_status: "Status", al_when: "When", al_all: "All",
    al_no_history: "No alerts logged", resend: "Resend", resend_sent: "Alerts resent",
    ch_telegram: "Telegram", ch_whatsapp: "WhatsApp", ch_call: "Call", ch_client_quote: "Quote email", ch_client_eta: "Arrival email", ch_call_retry: "Call retry",
  },
};

export const CATEGORIES = [
  { id: "porta_serratura", it: "Porta e Serratura", en: "Doors & Locks", icon: "KeyRound", badge_it: "Emergenza 24/7", badge_en: "24/7 Emergency" },
  { id: "tapparella", it: "Tapparelle e Avvolgibili", en: "Roller Shutters", icon: "PanelTopClose", badge_it: "Rapido", badge_en: "Fast" },
  { id: "mobili_fissaggi", it: "Mobili, Mensole e Fissaggi", en: "Furniture & Mounting", icon: "Hammer", badge_it: "Montaggio", badge_en: "Assembly" },
  { id: "porte_infissi", it: "Porte Interne ed Infissi", en: "Internal Doors & Windows", icon: "DoorOpen", badge_it: "Isolamento", badge_en: "Sealing" },
  { id: "impianti", it: "Impianti (elettrico/idraulico/gas)", en: "Systems (electric/water/gas)", icon: "Zap", badge_it: "Solo abilitati", badge_en: "Certified only" },
  { id: "altro", it: "Altro Problema", en: "Other Problem", icon: "Wrench", badge_it: "Personalizzato", badge_en: "Custom" },
];

export const STATUS_LABELS = {
  it: {
    richiesta_ricevuta: "Richiesta ricevuta", in_valutazione: "In valutazione", preventivo_inviato: "Preventivo inviato",
    accettato: "Accettato", tecnico_assegnato: "Tecnico assegnato", in_partenza: "In partenza", sul_posto: "Sul posto",
    in_lavorazione: "In lavorazione", completato: "Completato", pagato: "Pagato", rifiutato: "Rifiutato",
    annullato: "Annullato", variazione_da_approvare: "Variazione da approvare",
  },
  en: {
    richiesta_ricevuta: "Request received", in_valutazione: "Under review", preventivo_inviato: "Quote sent",
    accettato: "Accepted", tecnico_assegnato: "Technician assigned", in_partenza: "Departing", sul_posto: "On site",
    in_lavorazione: "In progress", completato: "Completed", pagato: "Paid", rifiutato: "Rejected",
    annullato: "Cancelled", variazione_da_approvare: "Variation to approve",
  },
};

export const STATUS_BADGE = {
  richiesta_ricevuta: "bg-blue-100 text-blue-800 border-blue-200",
  in_valutazione: "bg-amber-100 text-amber-800 border-amber-200",
  preventivo_inviato: "bg-purple-100 text-purple-800 border-purple-200",
  accettato: "bg-emerald-100 text-emerald-800 border-emerald-200",
  tecnico_assegnato: "bg-cyan-100 text-cyan-800 border-cyan-200",
  in_partenza: "bg-indigo-100 text-indigo-800 border-indigo-200",
  sul_posto: "bg-teal-100 text-teal-800 border-teal-200",
  in_lavorazione: "bg-amber-500 text-white border-amber-500",
  completato: "bg-green-600 text-white border-green-600",
  pagato: "bg-emerald-700 text-white border-emerald-700",
  rifiutato: "bg-rose-100 text-rose-800 border-rose-200",
  annullato: "bg-slate-100 text-slate-600 border-slate-200",
  variazione_da_approvare: "bg-orange-100 text-orange-800 border-orange-300",
};

export const ORDER_FLOW = ["richiesta_ricevuta", "in_valutazione", "preventivo_inviato", "accettato", "tecnico_assegnato", "in_partenza", "sul_posto", "in_lavorazione", "completato", "pagato"];

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("psof_lang") || "it");
  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "it" ? "en" : "it";
      localStorage.setItem("psof_lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || key, [lang]);
  return <LanguageContext.Provider value={{ lang, t, toggle }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
export const catLabel = (id, lang) => { const c = CATEGORIES.find((x) => x.id === id); return c ? c[lang] : id; };
export const statusLabel = (s, lang) => (STATUS_LABELS[lang] && STATUS_LABELS[lang][s]) || s;

export function timeAgo(iso, lang) {
  if (!iso) return "";
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const m = Math.floor(diff / 60000);
  const it = lang === "it";
  if (m < 1) return it ? "adesso" : "now";
  if (m < 60) return `${m} ${it ? "min fa" : "min ago"}`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} ${it ? "h fa" : "h ago"}`;
  const d = Math.floor(h / 24);
  return `${d} ${it ? "g fa" : "d ago"}`;
}

export const ALERT_STATUS = {
  sent: { key: "st_sent", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  failed: { key: "st_failed", cls: "bg-rose-100 text-rose-700 border-rose-200" },
  pending: { key: "st_pending", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  config_required: { key: "st_config", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  skipped: { key: "st_skipped", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};
